type UserAccountRequestOptionLike = {
  label?: string | null;
  sortOrder?: number | null;
  isActive?: boolean | null;
};

const normalizeOptionLabel = (value?: string | null) => `${value || ''}`.trim();

const compareOptionLabels = (left?: string | null, right?: string | null) => {
  return normalizeOptionLabel(left).localeCompare(normalizeOptionLabel(right), undefined, {
    sensitivity: 'base'
  });
};

export const sortRequestOptionsByConfiguredOrder = <T extends UserAccountRequestOptionLike>(rows: T[]) => {
  return [...(rows || [])].sort((left, right) => {
    const sortDelta = Number(left?.sortOrder || 0) - Number(right?.sortOrder || 0);
    if (sortDelta !== 0) return sortDelta;
    return compareOptionLabels(left?.label, right?.label);
  });
};

export const sortRequestOptionsAlphabetically = <T extends UserAccountRequestOptionLike>(rows: T[]) => {
  return [...(rows || [])].sort((left, right) => {
    const labelDelta = compareOptionLabels(left?.label, right?.label);
    if (labelDelta !== 0) return labelDelta;

    return Number(left?.sortOrder || 0) - Number(right?.sortOrder || 0);
  });
};

export const mapActiveOptionLabels = <T extends UserAccountRequestOptionLike>(
  rows: T[] | null | undefined,
  sortRows: (items: T[]) => T[] = sortRequestOptionsByConfiguredOrder
) => {
  const activeRows = Array.isArray(rows)
    ? rows.filter((row) => row?.isActive !== false && normalizeOptionLabel(row?.label).length > 0)
    : [];

  return sortRows(activeRows).map((row) => normalizeOptionLabel(row?.label));
};
